import { gql } from '@apollo/client/core'
import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

import { CLUB_FRAGMENT } from '@base/api/fragments/club'

export const CLUB_QUERY = gql`
  ${CLUB_FRAGMENT}
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${SERVER_ERROR}

  query getClub($slug: String) {
    getClub(clubSlug: $slug) {
      ... on GetClubOutput {
        club {
          ...Club
        }
      }

      ...UnauthenticatedError
      ...UnauthorizedError
      ...ServerError
    }
  }
`
